import axios from 'axios';

const ERROR_REPORT_PATH = '/api/web/v2/error_reports';

let _openModal = null;
let _lastErrorData = null;

export const registerErrorReportModal = (fn) => { _openModal = fn; };

export const getLastErrorData = () => _lastErrorData;

export const triggerErrorReportModal = () => {
  if (_openModal && _lastErrorData) _openModal(_lastErrorData);
};

const getBrowserInfo = () => ({
  user_agent: navigator.userAgent,
  platform: navigator.platform,
  language: navigator.language,
});

const parseRequestParams = (config) => {
  if (config?.params && Object.keys(config.params).length) return config.params;
  if (config?.data) {
    try {
      return typeof config.data === 'string' ? JSON.parse(config.data) : config.data;
    } catch {
      return undefined;
    }
  }
  return undefined;
};

export const sendErrorReport = async (data) => {
  const token = localStorage.getItem('session_token');
  if (!token) return;
  try {
    const baseUrl = process.env.REACT_APP_API_URL_BASE;
    await axios.post(`${baseUrl}${ERROR_REPORT_PATH}`, data, {
      headers: {
        'X-PI-TOKEN': token,
        'Content-Type': 'application/json',
      },
    });
  } catch (_) {
    // never throw — cannot add an error on top of an error
  }
};

export const setupErrorInterceptor = () => {
  axios.interceptors.response.use(
    (response) => {
      _lastErrorData = null;
      return response;
    },
    (error) => {
      const url = error.config?.url || '';

      if (url.includes(ERROR_REPORT_PATH)) {
        return Promise.reject(error);
      }

      _lastErrorData = {
        error_message: error.message,
        error_type: error.response ? 'api_error' : 'network_error',
        view_path: window.location.pathname,
        api_endpoint: error.config
          ? `${(error.config.method || 'GET').toUpperCase()} ${url}`
          : undefined,
        http_status: error.response?.status,
        api_response_message:
          error.response?.data?.mssg ||
          error.response?.data?.message ||
          error.response?.data?.error?.mssg ||
          error.response?.data?.error?.message ||
          undefined,
        request_params: parseRequestParams(error.config),
        browser_info: getBrowserInfo(),
      };

      return Promise.reject(error);
    }
  );
};
